import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RentPaymentModalWrapperComponent } from './rent-payment-modal-wrapper.component';
import { RentPaymentAddFormModule } from '../rent-payment-add-form/rent-payment-add-form.module';

import { ModalModule } from '../modal/modal.module';
import {FormMessageModule} from "../form-message/form-message.module";
import {LoaderButtonModule} from "../loader-button/loader-button.module";
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
    declarations: [
        RentPaymentModalWrapperComponent
    ],
    imports: [
        CommonModule,
        RentPaymentAddFormModule,
        ModalModule,
        FormMessageModule,
        LoaderButtonModule,
        PipesModule,
    ],
    exports: [
        RentPaymentModalWrapperComponent
    ]
})
export class RentPaymentModalWrapperModule {}


